import {API, getApiPath} from '@/lib/utils/api.utils';
import {GiftCardRedeem} from '@/types';

export const verifyGiftCard = async (
	code: string,
	locale: string,
	solveToken?: string
): Promise<GiftCardRedeem> => {
	const response = await API<GiftCardRedeem>(`${getApiPath()}/code/verify`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			'Cache-Control': 'no-store, no-cache',
			Expires: '0'
		},
		withCredentials: true,
		data: {code, locale, solveToken}
	});

	return response?.data;
};

export const redeemGiftCard = async (
	code: string,
	locale: string,
	solveToken?: string
): Promise<GiftCardRedeem> => {
	const response = await API<GiftCardRedeem>(`${getApiPath()}/code/redeem`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			'Cache-Control': 'no-store, no-cache',
			Expires: '0'
		},
		withCredentials: true,
		data: {code, locale, solveToken}
	});

	return response?.data;
};
